
import { Component, Vue } from 'vue-property-decorator'
import LsDialog from '@/components/ls-dialog.vue'
import lsPagination from '@/components/ls-pagination.vue'
import DatePicker from '@/components/date-picker.vue'
import { RequestPaging } from '@/utils/util'
import { apiInventorySalesLists, apiInventorySalesDetail, apiInventorySalesStatistics, apiInventoryShopList } from '@/api/channel/inventory'
@Component({ components: { LsDialog, lsPagination, DatePicker } })
export default class InventorySales extends Vue {
    $refs!: { detailDialog: any }
    salesStats: any = {}
    queryObj: any = { sid: '', order_sn: '', keyword: '', start_time: '', end_time: '' }
    pager: RequestPaging = new RequestPaging()
    shopList: any[] = []
    detailData: any = {}
    getStatistics() { apiInventorySalesStatistics({ sid: this.queryObj.sid || 0 }).then((res: any) => { this.salesStats = res || {} }).catch(() => {}) }
    getList(page?: number) { if (page) this.pager.page = page; this.pager.request({ callback: apiInventorySalesLists, params: { ...this.queryObj, sid: this.queryObj.sid || 0 } }) }
    handleReset() { this.queryObj = { sid: '', order_sn: '', keyword: '', start_time: '', end_time: '' }; this.getList(1) }
    handleDetail(row: any) { apiInventorySalesDetail({ id: row.id }).then((res: any) => { this.detailData = res || {}; this.$refs.detailDialog.open() }).catch(() => {}) }
    created() { apiInventoryShopList().then((res: any) => { this.shopList = res || [] }).catch(() => {}); this.getStatistics(); this.getList() }
}
